import { UseAPI, HandleRequestFail } from "@/assets/common"

export default () => UseAPI('/get/lessons', {
    method: "POST",
})
.catch((err) => Promise.reject(HandleRequestFail(err)))
